import { defineGridPlugin } from '@bingads-webui/projection-grid-plugin';
import { aggregatedRowsProjection } from './aggregated-rows-projection';

/**
 * The factory function to initialize the aggregated rows plugin on a grid
 * @param {GridView} gridView - The grid view the plugin being applied to
 * @param {Object} options - The configuration of the plugin
 * @param {Object} options.top - The configuration of top aggregated rows
 * @param {AggregatedRowsCallback} options.top.getRows -
 *    The callback to get the aggregated rows on top
 * @param {boolean} options.top.appendToHeader -
 *    Append top aggregated rows to header rows if true, otherwise, prepend them to body rows
 * @param {Object} options.bottom - The configuration of bottom aggregated rows
 * @param {AggregatedRowsCallback} options.bottom.getRows -
 *    The callback to get the aggregated rows at bottom
 * @param {boolean} options.bottom.prependToFooter -
 *    Prepend bottom aggregated rows to footer rows if true, otherwise, append them to body rows
 * @returns {void}
 */
function aggregatedRowsPluginFactory(gridView, options) {
  gridView.pipeStructureProjections(aggregatedRowsProjection);
  gridView.set({ aggregatedRows: options || {} });
}

export const aggregatedRowsPlugin = defineGridPlugin(
  'aggregatedRows',
  ['gridView'],
  aggregatedRowsPluginFactory
);
